import { render, staticRenderFns } from "./GLNameNumberCell.vue?vue&type=template&id=03e2245e&scoped=true"
import script from "./GLNameNumberCell.vue?vue&type=script&lang=js"
export * from "./GLNameNumberCell.vue?vue&type=script&lang=js"
import style0 from "./GLNameNumberCell.vue?vue&type=style&index=0&id=03e2245e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2245e",
  null
  
)

export default component.exports